import { ROLES } from "../constants"
import { store } from "../redux/store"


export const checkPermission = (item) => {
    const state = store.getState();
    const userPermissions = state.permissions.data;
    const role = localStorage.getItem("role");

    if (role === ROLES.ADMIN || role === ROLES.CUSTOMER) {
        return true;
    }
    const hasPermission = userPermissions
        .includes(item);
    return hasPermission
};
